import { showLoading, hideLoading } from 'react-redux-loading-bar';
import get from 'lodash/get';
import moment from 'moment';
import { shouldFetchItems } from './selectors';
import Http from '../../../http';
import HttpReports from '../../../httpReports';
import * as types from './constants';
import config from '../../../../config';

const ITEMS_PER_PAGE = 50;

const clearItems = () => ({ type: types.CLEAR_ITEMS });

const fetchItemsAction = items => ({
  type: types.FETCH_ITEMS,
  payload: items,
});

const fetchItems = (url, skip = 0) => dispatch =>
  Http.get(url, { limit: ITEMS_PER_PAGE, skip }).then((response) => {
    const items = get(response, 'rows', []);
    dispatch(fetchItemsAction(items));
    return (items.length === ITEMS_PER_PAGE);
  });

const fetchAllItems = endpoint => async (dispatch, getState) => {
  if (!shouldFetchItems(getState())) return;
  dispatch(clearItems());
  dispatch(showLoading());
  let skip = 0;
  let fetching = true;
  while (fetching) {
    fetching = await dispatch(fetchItems(endpoint, skip)); // eslint-disable-line
    skip += ITEMS_PER_PAGE;
  }
  dispatch(hideLoading());
};

export const fetchOwnerItems = (ownerId, ownerType) => fetchAllItems(`/${ownerType}/${ownerId}/marketing-lead`);

const fetchReport = url => dispatch => HttpReports.get(url).then((response) => {
  dispatch(clearItems());
  dispatch(fetchItemsAction(response));
});

export const fetchOwnerReport = (ownerId, ownerType, from, to, timezone) => {
  const fromDateTime = moment.tz(from, config.dateFormatISO, timezone).startOf('day').toJSON();
  const toDateTime = moment.tz(to, config.dateFormatISO, timezone).endOf('day').toJSON();
  return fetchReport(`/${ownerType}/${ownerId}/report/marketing-lead/${fromDateTime}/${toDateTime}`);
};

const fetchItem = url => dispatch =>
  Http.get(url).then(response =>
    dispatch({
      type: types.FETCH_ITEM,
      payload: response,
    })
  );
export const fetchOwnerItem = (ownerId, ownerType, id) => fetchItem(`/${ownerType}/${ownerId}/marketing-lead/${id}`);

const addItemAction = payload => ({
  type: types.ADD_ITEM,
  payload,
});

const addItem = (url, data) => dispatch =>
  Http.post(url, data).then(response => dispatch(addItemAction(response)));
export const addOwnerItem = (ownerId, ownerType, data) => addItem(`/${ownerType}/${ownerId}/marketing-lead`, data);

const updateItemAction = payload => ({
  type: types.UPDATE_ITEM,
  payload,
});
const updateItem = (url, data) => dispatch =>
  Http.put(url, data, ['image', 'photos']).then(response => dispatch(updateItemAction(response)));
export const updateOwnerItem = (ownerId, ownerType, id, data) => updateItem(`/${ownerType}/${ownerId}/marketing-lead/${id}`, data);

const deleteItem = (url, id) => dispatch =>
  Http.delete(url).then(() =>
    dispatch({
      type: types.DELETE_ITEM,
      payload: id,
    })
  );
export const deleteOwnerItem = (ownerId, ownerType, id) => deleteItem(`/${ownerType}/${ownerId}/marketing-lead/${id}`, id);
